function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";
export default (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "-5 -5 30 30",
  strokeWidth: "1.5"
}, props), /*#__PURE__*/React.createElement("path", {
  d: "M15.469 20.168a1.406 1.406 0 01-1.781 1.356l-9.844-2.735a1.406 1.406 0 01-1.031-1.351V2.332A1.406 1.406 0 014.594.976l9.844 3.179a1.406 1.406 0 011.031 1.355z",
  fill: "none",
  stroke: "#000",
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M4.219.925h14.063a1.406 1.406 0 011.406 1.406v14.766a1.406 1.406 0 01-1.406 1.406h-2.813",
  fill: "none",
  stroke: "#000",
  strokeLinecap: "round",
  strokeLinejoin: "round"
})));